import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as JotaiProvider } from 'jotai';

import { jotaiStore } from '@shared/store/jotai/jotai-store';
import App from '@app/App';

import '@app/i18n';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');

if (!container) {
  throw new Error(
    `Root element '#root' not found — HTML must include <div id="root"></div> (see root index.html).`
  );
}

const root = createRoot(container);

root.render(
  <React.Fragment>
    <Suspense fallback="">
      <JotaiProvider store={jotaiStore}>
        <App />
      </JotaiProvider>
    </Suspense>
  </React.Fragment>
);

serviceWorker.unregister();
